export const textRowsPerPage = "表示件数"
export const otherDrug = "その他"
export const noData = "データなし"